import $ from 'jquery'
import { formatMoney } from '@shopify/theme-currency'

// Helpers
import storefrontQuery from 'assets/scripts/helpers/storefront-api-helper'
import { getItemCartQuantity } from './get-cart-quantity'

const MAX_CART_QUANTITY = 9 // TODO: can we move this to be served from the theme editor?

/**
 * Module to ajaxify all add to cart forms on the page.
 *
 * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

var finalSaleTag = 'final-sale',
  translations = window.translations,
  localeUrl = window.localeUrl

export const updateCartCount = async () => {
  const cartItemCount = document.querySelectorAll('.cart__item-count')
  if (!cartItemCount.length) return

  const cartResponse = await fetch(localeUrl + '/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      cache: false,
    },
  })

  const parsedCartResponse = await cartResponse.json()
  for (let i = 0; i < cartItemCount.length; i++) {
    cartItemCount[i].innerText = parsedCartResponse.item_count
  }
}

function getAddedSubtotal(items) {
  let subtotal = 0

  items.forEach((item) => {
    // if item is already in cart, get the value of the item just added, ignoring what's already in cart
    if (item.quantity > 1) {
      const itemPrice = item.final_line_price / item.quantity
      subtotal = subtotal + itemPrice
    } else {
      subtotal = subtotal + item.final_line_price
    }
  })

  return subtotal / 100 // divide to get decimal value
}

function getFormattedItems(items) {
  let arrayOfItems = []

  for (let i = 0; i < items.length; i++) {
    const formattedItem = {
      item_id: items[i].id,
      item_name: items[i].title,
      item_category: items[i].product_type,
      quantity: items[i].quantity,
      price: items[i].price / 100,
    }
    arrayOfItems.push(formattedItem)
  }
  return arrayOfItems
}

/**
 * formData should be an object with an `items` array. `items` should be an array of objects with `id` and `selling_plan_id` (if subscription item)
 * @param {*} formData
 */
export const ajaxAddToCartCallWithFetch = (formData) => {
  return fetch(window.location.origin + '/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json()
    })
    .then((response) => {
      const { items } = response
      const addedSubtotal = getAddedSubtotal(items)
      const formattedItems = getFormattedItems(items)

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: 'add_to_cart_dsc',
        addedSubtotal: addedSubtotal,
        ecommerce: {
          items: formattedItems,
        },
      })

      updateCartCount()

      Shopify.miniCart.init()

      // Update free shipping progress
      Shopify.freeShippingProgress.init()

      return response
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}

export async function lineItemCardHtml($itemData, $lineItemAddedQuantity = 0) {
  // Populate line item into card
  var $lineItemCard = ''

  // Get item image
  var $lineItemImage = ''

  if (typeof $itemData.image != 'undefined' && $itemData.image != '') {
    $lineItemImage = $itemData.image
  } else if ($itemData.featured_image.url) {
    $lineItemImage = itemData.featured_image.url
  }

  // Get item url
  var $lineItemUrl = $itemData.url
  // Get item title
  var $lineItemTitle = $itemData.product_title
  // Get item prices
  var $lineItemPrice = formatMoney($itemData.price, theme.moneyFormat), // Current Price
    $lineItemOriginalPrice = formatMoney(
      $itemData.original_price,
      theme.moneyFormat,
    ), // Original Price
    $lineItemComparePrice = '',
    $lineItemComparePriceRaw = null
  // Get variant title
  if ($itemData.variant_title != null) {
    var $lineItemVariantTitle = $itemData.variant_title.replace(' / ', ', ')
  }

  var $subscriptionFrequency = 0,
    $subscriptionFrequencyLabel = '',
    $hasSubscription = false

  // Get item selling plans data
  if (typeof $itemData.selling_plan_allocation != 'undefined') {
    var $lineItemSellingPlan = $itemData.selling_plan_allocation.selling_plan

    // Get OG selling plan by getting selling plan option equal to "Deliver every"
    for (let index = 0; index < $lineItemSellingPlan.options.length; index++) {
      var $sellingPlanOption = $lineItemSellingPlan.options[index]
      var $optionName = $sellingPlanOption.name
      var $optionValue = $sellingPlanOption.value

      if ($optionName == 'Delivery every') {
        $hasSubscription = true
        $subscriptionFrequencyLabel = $optionName
        $subscriptionFrequency = $sellingPlanOption.value
        break
      }
    }
  }

  // Get product handle
  var $productHandle = $itemData.handle
  // Final Sale Product - Check if the product is final sale or not based on tags
  var $isFinalSale = false
  $.ajax({
    url: localeUrl + '/products/' + $productHandle + '.js',
    dataType: 'json',
    async: false,
    success: function (product) {
      // get product compare at price max
      $.each(product.variants, function (index, value) {
        if ($itemData.id == value.id) {
          $lineItemComparePrice = formatMoney(
            value.compare_at_price,
            theme.moneyFormat,
          )
          $lineItemComparePriceRaw = value.compare_at_price
        }
      })

      // Get product tags
      $.each(product.tags, function (index, value) {
        if (value == finalSaleTag) {
          $isFinalSale = true
          return false
        }
      })
    },
  })

  // Hidden product - Checks if the product PDP must be hidden based on metafield
  const productGraphQL = `{
        product(handle:"${$productHandle}") {
            title
            metafield: metafield(key:"hidden_product", namespace:"iamota") {
                value
            }
            nextShipmentSubscriptionProductVariantID: metafield(key:"subscription_product_variant_id", namespace: "iamota") {
                value
            }
            nextShipmentSubscriptionProductHandle: metafield(key:"subscription_product_handle", namespace: "iamota") {
                value
            }
            bundleProductsList: metafield(key:"bundle_products_list", namespace: "iamota") {
                value
            }
        }
    }`
  const productMeta = await storefrontQuery(productGraphQL)

  if (!productMeta.data.product) return

  const isHidden = productMeta.data.product.metafield?.value == 'true' ? true : false
  const nextShipmentSubscriptionProductHandle =
    productMeta.data.product.nextShipmentSubscriptionProductHandle?.value
  const nextShipmentSubscriptionProductVariantID =
    productMeta.data.product.nextShipmentSubscriptionProductVariantID?.value
  let bundleProductsList = productMeta.data.product.bundleProductsList?.value
  let isBundle = false
  let hasFutureShipmentProduct = false

  if (bundleProductsList !== undefined) {
    isBundle = true
    bundleProductsList = JSON.parse(bundleProductsList)
  }

  if (
    nextShipmentSubscriptionProductHandle !== undefined &&
    nextShipmentSubscriptionProductVariantID !== undefined
  ) {
    hasFutureShipmentProduct = true
    var nextShipmentSubscriptionProduct
    var nextShipmentSubscriptionProductVariant
    var nextShipmentSubscriptionProductFeaturedImage

    await jQuery.getJSON(
      window.Shopify.routes.root +
        `products/${nextShipmentSubscriptionProductHandle}.js`,
      function (product) {
        nextShipmentSubscriptionProduct = product
      },
    )

    if (nextShipmentSubscriptionProduct !== undefined) {
      const productVariants = nextShipmentSubscriptionProduct.variants
      for (let index = 0; index < productVariants.length; index++) {
        const element = productVariants[index]

        if (element.id == nextShipmentSubscriptionProductVariantID) {
          nextShipmentSubscriptionProductVariant = element
          break
        }
      }
    }

    nextShipmentSubscriptionProductFeaturedImage =
      nextShipmentSubscriptionProductVariant.featured_image !== null
        ? nextShipmentSubscriptionProductVariant.featured_image
        : nextShipmentSubscriptionProduct.featured_image
  }

  $lineItemCard +=
    '<article class="card card--default card--line-item card--line-item--placeholder">'
  // Remove link if hidden
  if (isHidden) {
    $lineItemCard += '<div tabindex="-1">'
    if ($lineItemImage !== null && $lineItemImage != '') {
      $lineItemCard +=
        '<img class="line-item__image" src="' + $lineItemImage + '"/>'
    }
    $lineItemCard += '</div>'
  } else {
    // Image with link
    $lineItemCard += '<a tabindex="-1" href=' + $lineItemUrl + '>'
    if ($lineItemImage !== null && $lineItemImage != '') {
      $lineItemCard +=
        '<img class="line-item__image" src="' + $lineItemImage + '"/>'
    }

    if ($hasSubscription && !hasFutureShipmentProduct) {
      $lineItemCard += `<span class="line-item--image__footer"><p>Subscription</p></span>`
    }

    $lineItemCard += '</a>'
  }
  $lineItemCard += '<div class="">'
  // Title
  if ($lineItemTitle.length) {
    $lineItemCard += '<h3 class="card__title">' + $lineItemTitle + '</h3>'
  }

  if (isBundle) {
    $lineItemCard += `<p class='card__bundle-products-count'>${bundleProductsList.length} Items Included</p>`
  }

  // Meta
  $lineItemCard += '<div class="card__metadata">'
  // Variant Title
  if (typeof $lineItemVariantTitle != 'undefined') {
    $lineItemCard +=
      '<p class="line-item__variant-title">' + $lineItemVariantTitle + '</p>'
  }

  // Quantity
  if ($lineItemAddedQuantity > 0) {
    var $lineItemQuantity = $lineItemAddedQuantity
  } else {
    var $lineItemQuantity = $itemData.quantity
  }
  $lineItemCard +=
    '<p class="line-item__added-quantity">' +
    translations.longQuantity +
    ': ' +
    $lineItemQuantity +
    '</p>'

  if ($hasSubscription && !hasFutureShipmentProduct) {
    $lineItemCard += `<p class="line-item__subscription-frequency"><span class="icon cart__item--frequency-icon"><svg class="icon icon__frequency"><use xlink:href="#icon-frequency"></use></svg></span> ${$subscriptionFrequencyLabel} ${$subscriptionFrequency}</p>`
  }

  // Prices
  $lineItemCard += '<div data-price-wrapper="" class="card__price">'
  if ($lineItemOriginalPrice != $lineItemPrice) {
    $lineItemCard +=
      '<span class="visually-hidden" data-original-price-text="">Original Price</span>'
    $lineItemCard +=
      '<s data-original-price="">' + $lineItemOriginalPrice + '</s>'
  } else if ($lineItemComparePriceRaw != null) {
    $lineItemCard +=
      '<span class="visually-hidden" data-compare-text="">Regular price</span>'
    $lineItemCard +=
      '<s data-compare-price="" class="card__price--sale">' +
      $lineItemComparePrice +
      '</s>'
  }
  $lineItemCard +=
    '<span data-product-price="" class="card__price--original">' +
    $lineItemPrice +
    '</span>'
  $lineItemCard += '</div>'

  // Final Sale
  if ($isFinalSale == true) {
    $lineItemCard += '<div class="line-item__final-sale">'
    $lineItemCard += '<span>' + translations.finalSaleLabel + '</span>'
    $lineItemCard += '<div class="tooltip tooltip--default">'
    // Tooltip Icon - Final Sale svg - should include via css?
    $lineItemCard +=
      '<span class="tooltip__icon tooltip__icon--final-sale"><svg class="icon icon__tooltip"><use xlink:href="#icon-tooltip"></use></svg></span>'
    // Tooltip Description - Final Sale
    $lineItemCard +=
      '<div class="tooltip__content">' +
      translations.finalSaleMessage +
      '</div>'
    $lineItemCard += '</div>'
    $lineItemCard += '</div>'
  }

  $lineItemCard += '</div></div>'

  $lineItemCard += '</article>'

  // Add Next Shipment Subscription Product Card to below the Starter Set
  if (hasFutureShipmentProduct) {
    const nextShipmentSubscriptionProductFrequencyLabel = `${$optionName} ${$optionValue} for`
    const futureShipmentHeading = translations.futureShipmentHeading

    var template = $('#next-shipment-subscription-product-article-template')
      .html()
      .replace('{FUTURE_SHIPMENT_HEADING}', futureShipmentHeading)
      .replace('{PRODUCT_TITLE}', nextShipmentSubscriptionProduct.title)
      .replace('{PRODUCT_URL}', nextShipmentSubscriptionProduct.url)
      .replace('{PRODUCT_IMAGE}', nextShipmentSubscriptionProductFeaturedImage)
      .replace(
        '{PRODUCT_SELLING_PLAN_NAME}',
        nextShipmentSubscriptionProductFrequencyLabel,
      )
      .replace(
        '{PRODUCT_PRICE}',
        formatMoney(
          nextShipmentSubscriptionProductVariant.price,
          theme.moneyFormat,
        ),
      )

    $lineItemCard += template
  }

  return $lineItemCard
}

// Get current cart information and output as html
export function cartSubtotalUpdate(cartData) {
  var _config = {
    cartCountSelector: '.cart__item-count',
  }

  // Get number of items in cart
  var $cartItemsNum = parseInt(cartData.item_count)
  if ($cartItemsNum > 1) {
    var $cartItemsNumLabel = translations.itemCountOther
  } else {
    var $cartItemsNumLabel = translations.itemCountOne
  }

  var $subTotalLabel = translations.subTotalLabel

  // Get items subtotal price
  var $cartSubtotal = formatMoney(
    cartData.original_total_price,
    theme.moneyFormat,
  )

  var $cartTotal = formatMoney(cartData.total_price, theme.moneyFormat)

  // Get items discount price
  var $cartDiscount = formatMoney(cartData.total_discount, theme.moneyFormat)

  if ($('.cart-subtotal__container').length) {
    $.each($('.cart-subtotal__container'), function () {
      $(this)
        .find('.cart-info__item-count')
        .text(
          $subTotalLabel +
            ' (' +
            $cartItemsNum +
            ' ' +
            $cartItemsNumLabel +
            ')',
        )
      $(this).find('.cart-info__subtotal').text($cartSubtotal)
    })
  }

  // Update Estimated Total
  if ($('.cart__total-price').length) {
    $('.cart__total-price').text($cartTotal)
  }

  if ($('.cart-price--discount').length) {
    $('.cart-price--discount').text('-' + $cartDiscount)
  }

  // Update cart count
  if ($(_config.cartCountSelector).length) {
    $(_config.cartCountSelector).text(cartData.item_count)
  }
}

$(document).ready(function () {
  Shopify.AjaxifyCart = (function ($) {
    // use it to get the item quantity in the cart to determine how min/max should work.
    let itemCartQuantity = getItemCartQuantity()

    // Some configuration options.
    // I have separated what you will never need to change from what
    // you might change.

    var _config = {
      // What you might want to change
      addToCartBtnLabel: translations.addToCart,
      addedToCartBtnLabel: translations.addingToCart,
      addingToCartBtnLabel: translations.addingToCart,
      soldOutBtnLabel: translations.soldOut,
      howLongTillBtnReturnsToNormal: 800, // in milliseconds.
      cartCountSelector: '.cart__item-count',
      cartTotalSelector: '#cart-price',

      // What you will never need to change
      addToCartBtnSelector: '.btn--add-to-cart--quick',
      addToCartFormSelector: 'form[action="/cart/add"]',
      shopifyAjaxAddURL: localeUrl + '/cart/add.js',
      shopifyAjaxCartURL: localeUrl + '/cart.js',
      productPriceWrapper: '[data-price-wrapper]',
      productComparePrice: '[data-compare-price]',
      productQuantityInput: 'input[name="quantity"]',

      // Cart Confirmation Modal configs
      cartModal: '.modal--cart-confirmation',
      cartModalMessage: '.cart-confirmation__message',
      cartModalItem: '.cart-confirmation__item',
      cartModalCartInfo: '.cart-subtotal__container',
      cartModalSubscriptionInfo: '.cart__subscription-info',
    }

    const $this = $(this)
    let $limit = MAX_CART_QUANTITY
    let $maxQuantityInCart = false

    // PDP Add to Cart events for data layer
    // TODO: does not work with digioh quiz "Add to Cart" button under products
    $('#add-to-cart-button, .btn--add-to-cart--quick').on('click', function () {
      window.dataLayer = window.dataLayer || []
      var dataLayer = window.dataLayerData

      window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.

      // GTM
      window.dataLayer.push({
        event: 'add_to_cart_dsc',
        // TODO: Refactor all dependencies to use ecommerce and remove product
        product: {
          productId: dataLayer.product['id'],
          price: dataLayer.product['price'],
          name: dataLayer.product['title'],
        },
        ecommerce: {
          items: [
            {
              item_id: dataLayer.product['id'],
              item_name: dataLayer.product['title'],
              item_category: dataLayer.product['type'],
              price: dataLayer.product['price'],
            },
          ],
        },
      })
    })

    // Handle add to cart via permalink, for landing pages

    function getShopAbbr() {
      const shopId = window.Shopify.shopId
      switch (shopId) {
        case '56839438384':
          return 'us'
          break
        case '80159539522':
          return 'uk'
          break
        case '77535543589':
          return 'au'
          break
        case '79541436705':
          return 'ca'
          break
        case '66859172052':
          return 'release'
          break
        default:
          return ''
      }
    }
    const shopAbbr = getShopAbbr()

    // TODO: Make these values editable in theme UI
    const subscriptionItems = {
      us: [
        '40643312779312', // 4-blade
        '40643312812080', // 6-blade
      ],
      uk: [
        '46009016680770', // 4-blade
        '46009016254786', // 6-blade
      ],
      au: [
        '45386492543269', // 4-blade
        '45386494312741', // 6-blade
      ],
      ca: [
        '46758377259297', // 4-blade
        '46758412910881', // 6-blade
      ],
      release: [
        '8022247309524', // 4-blade
        '44056852234452', // 6-blade
      ],
    }

    // TODO: Make these values editable in theme UI
    const sellingPlans = {
      us: {
        oneMonth: 1238368304,
        twoMonth: 1349451824,
      },
      uk: {
        oneMonth: 690043748674,
        twoMonth: 690043781442,
      },
      au: {
        oneMonth: 689132929317,
        twoMonth: 689132962085,
      },
      ca: {
        oneMonth: 688895492385,
        twoMonth: 688895525153,
      },
      release: {
        oneMonth: 2899869908,
        twoMonth: 2899902676,
      },
    }

    function getAddedSubtotal(items) {
      let subtotal = 0

      items.forEach((item) => {
        // if item is already in cart, get the value of the item just added, ignoring what's already in cart
        if (item.quantity > 1) {
          const itemPrice = item.final_line_price / item.quantity
          subtotal = subtotal + itemPrice
        } else {
          subtotal = subtotal + item.final_line_price
        }
      })

      return subtotal / 100 // divide to get decimal value
    }

    function getFormattedItems(items) {
      let arrayOfItems = []

      for (let i = 0; i < items.length; i++) {
        const formattedItem = {
          item_id: items[i].id,
          item_name: items[i].title,
          item_category: items[i].product_type,
          quantity: items[i].quantity,
          price: items[i].price / 100,
        }
        arrayOfItems.push(formattedItem)
      }
      return arrayOfItems
    }

    $('.cart-api-add-btn').on('click', function (event) {
      event.preventDefault()
      var url = $(this).attr('href')

      // one product w/ selling plan
      if (url.includes('cart/add?')) {
        var formatUrlForParams = new URL(url)
        var params = new URLSearchParams(formatUrlForParams.search)
        var productId = params.get('id')
        var sellingPlanId = params.get('selling_plan')

        var formData = {
          items: [
            {
              id: productId,
              selling_plan: sellingPlanId,
            },
          ],
        }

        fetch(window.location.origin + '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json()
          })
          .then((response) => {
            const { items } = response
            const addedSubtotal = getAddedSubtotal(items)
            const formattedItems = getFormattedItems(items)

            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
            window.dataLayer.push({
              event: 'add_to_cart_dsc',
              addedSubtotal: addedSubtotal,
              ecommerce: {
                items: formattedItems,
              },
            })

            window.location.assign(window.location.origin + '/cart')
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }
      // multiple products w/ quantity and discount code
      else if (url.includes('cart/') && !url.includes('cart/add?')) {
        // split by `?` if it exists
        var splitProductsAndDiscounts = url.split('?')
        var productsPartOfUrl = splitProductsAndDiscounts[0]
        var discountsPartOfUrl = splitProductsAndDiscounts[1]

        // Get discount code
        if (discountsPartOfUrl && discountsPartOfUrl.includes('discount=')) {
          var discountCode = discountsPartOfUrl.substring(
            discountsPartOfUrl.indexOf('discount=') + 9,
          )
        }

        // Handle items
        var firstSplit = productsPartOfUrl.split('/cart/')
        var products = firstSplit[1].split(',')

        var items = []
        var sellingPlanId = null

        if ($(this).hasClass('one-month')) {
          sellingPlanId = sellingPlans[shopAbbr]['oneMonth']
        } else if ($(this).hasClass('two-months')) {
          sellingPlanId = sellingPlans[shopAbbr]['twoMonth']
        }

        products.forEach((productWithQuantity) => {
          var product = productWithQuantity.split(':')
          var id = product[0]
          var quantity = product[1]

          if (subscriptionItems[shopAbbr].includes(id)) {
            items.push({
              id: id,
              quantity: quantity,
              selling_plan: sellingPlanId,
            })
          } else {
            items.push({
              id: id,
              quantity: quantity,
            })
          }
        })

        let formData = {
          items: items,
        }

        fetch(window.location.origin + '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json()
          })
          .then((response) => {
            const { items } = response
            const addedSubtotal = getAddedSubtotal(items)
            const formattedItems = getFormattedItems(items)

            let includesSubscription = false

            for (let i = 0; i < items.length; i++) {
              if (items[i].selling_plan_allocation) {
                includesSubscription = true
                break
              }
            }

            if (url.includes('cart/')) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
              window.dataLayer.push({
                event: 'add_to_cart_dsc',
                subtotal: addedSubtotal,
                ecommerce: {
                  items: formattedItems,
                },
              })
            }

            const redirectToCheckout = $(this).hasClass(
              'redirect-to-checkout-true',
            )
            let redirectPath = '/cart'
            if (redirectToCheckout && discountCode) {
              redirectPath = `/checkout?discount=${discountCode}`

              // fire checkout_started event
              window.dataLayer.push({
                event: 'checkout_started',
              })

              // fire subscription_purchase_started event if applicable
              if (includesSubscription) {
                window.dataLayer.push({
                  event: 'subscription_purchase_started',
                })
              }
            } else if (redirectToCheckout) {
              redirectPath = `/checkout`

              // fire checkout_started event
              window.dataLayer.push({
                event: 'checkout_started',
              })

              // fire subscription_purchase_started event if applicable
              if (includesSubscription) {
                window.dataLayer.push({
                  event: 'subscription_purchase_started',
                })
              }
            } else if (discountCode) {
              const firstDiscountCode = discountCode.split(',')[0]
              redirectPath = `/discount/${firstDiscountCode}?redirect=/cart`
            }

            window.location.assign(
              window.location.origin + redirectPath, // Apply discount code then redirect to cart
            )
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }
      // Fallback to normal url handling in case of incorrect theme setting (Is Cart API link selected, but url does not fit the Cart API format)
      else {
        window.location.assign(url)
      }
    })

    // handles digioh quiz page "add all product to cart" button
    $('.digioh-quiz-add-all-to-cart').on('click', function (e) {
      e.preventDefault()

      let productsForAddAll = []
      const recommendedProducts = document.querySelectorAll(
        '.card--product-quiz',
      )
      for (let i = 0; i < recommendedProducts.length; i++) {
        const product = recommendedProducts[i]
        const productIdSelector =
          product.querySelector('select') || product.querySelector('input')
        let productId = productIdSelector.value
        const sellingPlanIdSelector = product.querySelector(
          'input[name="selling_plan"]',
        )
        let sellingPlanId = sellingPlanIdSelector
          ? sellingPlanIdSelector.value
          : ''

        if (sellingPlanId) {
          productsForAddAll.push({
            id: productId,
            selling_plan: sellingPlanId,
            quantity: 1,
          })
        } else {
          productsForAddAll.push({
            id: productId,
            quantity: 1,
          })
        }
      }

      fetch(window.location.origin + '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: productsForAddAll,
        }),
      })
        .then((response) => {
          return response.json()
        })
        .then((response) => {
          const { items } = response
          const addedSubtotal = getAddedSubtotal(items)
          const formattedItems = getFormattedItems(items)

          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
          window.dataLayer.push({
            event: 'add_to_cart_dsc',
            subtotal: addedSubtotal,
            ecommerce: {
              items: formattedItems,
            },
          })

          window.location.assign(window.location.origin + '/cart')
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    })

    const setProductVariantQuantityLimits = function () {
      getItemCartQuantity().done((itemCartQuantityData) => {
        // verify that we are at an items "max quantity" for a cart
        const variantItemId = $('#ProductSelect')[0].value
        const cartItemIdToQuantity = $.parseJSON(itemCartQuantityData)
        const cartItemQuantity = cartItemIdToQuantity[variantItemId] || 0

        if (cartItemQuantity) {
          if (cartItemQuantity >= MAX_CART_QUANTITY) {
            // the item is at max quantity in the cart - set to zero
            $('#add-to-cart-button').attr({
              disabled: true,
            })
            $maxQuantityInCart = true
            $('#Quantity')[0].value = 0
            $('#MaxQuantityMessage')
              .empty()
              .append(`<p>${window.translations.maxQuantityMessage}</p>`)
          } else if (cartItemQuantity >= 0) {
            // the item is at "some" quantity in the cart - figure out if will go past the maximum limit
            $maxQuantityInCart = false
            $limit = MAX_CART_QUANTITY - cartItemQuantity
            $('#Quantity')[0].value = 1
            $('#MaxQuantityMessage').empty()
          }
        } else {
          $maxQuantityInCart = false
          $limit = MAX_CART_QUANTITY
          $('#Quantity')[0].value = 1
          $('#MaxQuantityMessage').empty()
        }
      })
    }

    // sets the UI based on the items in the cart per the variant.
    if (document.getElementById('ProductSelect')) {
      setProductVariantQuantityLimits()
    }

    // We need some feedback when adding an item to the cart.
    // Here it is.
    var _showFeedback = function ($itemData) {
      // Remove current subscription message from the confirmation modal.
      $(_config.cartModalSubscriptionInfo).empty()
      var $hasSubscription = false,
        $subscriptionFrequency = 0,
        $subscriptionMessage = ''

      // Get item selling plans data
      if (typeof $itemData.selling_plan_allocation != 'undefined') {
        var $lineItemSellingPlan =
          $itemData.selling_plan_allocation.selling_plan

        // Get OG selling plan by getting selling plan option equal to "Deliver every"
        for (
          let index = 0;
          index < $lineItemSellingPlan.options.length;
          index++
        ) {
          const $sellingPlanOption = $lineItemSellingPlan.options[index]
          const $optionName = $sellingPlanOption.name

          if ($optionName == 'Delivery every') {
            $hasSubscription = true
            $subscriptionFrequency = $sellingPlanOption.value
            break
          }
        }
      }

      if ($hasSubscription) {
        $subscriptionMessage =
          `<p>This subscription item will continue to ship and bill every ` +
          $subscriptionFrequency +
          ` until canceled.</p>`
        $(_config.cartModalSubscriptionInfo).html($subscriptionMessage)
      }

      $(_config.cartModalMessage).html(
        '<svg class="icon icon__check--circle"><use xlink:href="#icon-check--circle"></use></svg> ' +
          translations.modalSuccessMessage,
      )

      // Get product quantity added to cart
      var $lineItemAddedQuantity = $(_config.addToCartFormSelector)
        .find(_config.productQuantityInput)
        .val()

      // Get Added Item info and append to the modal
      lineItemCardHtml($itemData, $lineItemAddedQuantity).then(
        ($lineItemCardHtml) => {
          $(_config.cartModalItem).html($lineItemCardHtml)
        },
      )
      // Open the modal after the item is added
      var $modal = $(_config.cartModal)
      $modal.addClass('modal--open')
      $('body').addClass('noscroll--modal')

      $modal.find('[tabindex="-1"]').each(function () {
        $(this).attr('tabindex', 0)
      })

      // Broadcast a notification that a modal opened
      $(window).trigger('open.modal', $modal)
    }

    var _setText = function ($button, label) {
      if ($button.children().length) {
        $button.children().each(function () {
          if ($.trim($(this).text()) !== '') {
            $(this).text(label)
          }
        })
      } else {
        $button.text(label)
      }
    }

    $('body').on('change', '#Quantity', function () {
      var $this = $(this)

      if ($maxQuantityInCart) {
        // reached max quantity in cart... prevent quantity changes and show message
        $this.val(0)
        $('#MaxQuantityMessage')
          .empty()
          .append(`<p>${window.translations.maxQuantityMessage}</p>`)
      } else if ($this.val() < 0) {
        // If user input negative quantities, force input value to 1
        $this.val(1)
        $('#MaxQuantityMessage').empty()
      } else if ($this.val() > $limit) {
        $this.val($limit)
        $('#MaxQuantityMessage')
          .empty()
          .append(`<p>${window.translations.maxQuantityMessage}</p>`)
      } else {
        $('#MaxQuantityMessage').empty()
      }
    })

    $('.form__element')
      .find('input[type=radio]')
      .on('change', (e) => {
        // listen for variant swap and update the limits
        setProductVariantQuantityLimits()
      })

    var _init = function () {
      $(document).ready(function () {
        // Empty the cart if there are only free sample products in cart

        $.ajax({
          url: _config.shopifyAjaxCartURL,
          cache: false,
          dataType: 'json',
          success: function (cart) {
            var cart_items_subtotal_price = cart.items_subtotal_price
            var cart_item_count = cart.item_count
            if (cart_items_subtotal_price == 0 && cart_item_count > 0) {
              $.ajax({
                type: 'POST',
                url: localeUrl + '/cart/clear.js',
                data: '',
                dataType: 'json',
                success: function () {
                  location.reload(true)
                },
                error: function (XMLHttpRequest, textStatus) {
                  /* error code */
                },
              })
            }
          },
        })

        if ($(_config.addToCartFormSelector).attr('data-is-ajax') == 'true') {
          // happens when the user clicks "Add to Cart"
          $('body').on(
            'submit',
            '' + _config.addToCartFormSelector + '',
            function (e) {
              e.preventDefault()

              // Remove error message
              $('.cart__message--error').text('')

              var $addToCartForm = $(this),
                $addToCartBtn = $addToCartForm.find(
                  _config.addToCartBtnSelector,
                ),
                $addToCartText = $addToCartForm.find('[data-add-to-cart-text]'),
                $addToCartBtnCard = $addToCartForm.find(
                  '.quick-cart-add__loader',
                ),
                $addToCartType = $addToCartForm.attr('data-add-cart-type')

              //Get current label to reapply after cart submitted
              _config.addToCartBtnLabel = $addToCartText.text()

              if (
                $('body').hasClass('template-product') &&
                $addToCartForm.hasClass('quick-cart-add__product-hero')
              ) {
                _setText($addToCartText, _config.addingToCartBtnLabel)
              } else if ($addToCartForm.attr('data-add-cart-type') == 'modal') {
                // Cart Modal case
                // Change Button Text to indicate that product is adding to cart
                _setText($addToCartText, _config.addingToCartBtnLabel)
                $addToCartBtn.addClass('disabled').prop('disabled', true)
                $addToCartBtn.addClass('button--active')
              } else {
                _setText($addToCartBtnCard, _config.addingToCartBtnLabel)
              }

              // Add to cart
              // NOTE: change this fetch when we can
              $.ajax({
                url: _config.shopifyAjaxAddURL,
                dataType: 'json',
                type: 'post',
                data: $addToCartForm.serialize(),
                success: function (itemData) {
                  // update limit to new limit based on quantity
                  $limit = MAX_CART_QUANTITY - itemData.quantity

                  // Re-enable add to cart button.
                  $addToCartBtnCard.addClass('button--active')

                  if ($addToCartForm.attr('data-add-cart-type') == 'modal') {
                    // // Update mini cart
                    Shopify.miniCart.init()

                    // Update free shipping progress
                    Shopify.freeShippingProgress.init()
                  }

                  if (
                    $('body').hasClass('template-product') &&
                    $addToCartForm.hasClass('quick-cart-add__product-hero')
                  ) {
                    _setText($addToCartText, _config.addedToCartBtnLabel)
                    $addToCartBtn.addClass('disabled').prop('disabled', true)
                    $addToCartBtn.addClass('button--active')
                  } else {
                    _setText($addToCartBtnCard, _config.addedToCartBtnLabel)
                  }

                  window.setTimeout(function () {
                    // only remove the disable if we haven't reached max quantity
                    if (itemData.quantity < MAX_CART_QUANTITY) {
                      $addToCartBtnCard.removeClass('button--active')
                      $addToCartBtn.removeClass('button--active')
                      $addToCartBtn
                        .removeClass('disabled')
                        .prop('disabled', false)
                      if ($('#Quantity')[0]) {
                        $('#Quantity')[0].value = 1
                      }
                    } else {
                      if ($('#Quantity')[0]) {
                        $('#Quantity')[0].value = 0
                      }
                    }

                    if (
                      $('body').hasClass('template-product') &&
                      $addToCartForm.hasClass('quick-cart-add__product-hero')
                    ) {
                      _setText($addToCartText, _config.addToCartBtnLabel)
                    } else if (
                      $addToCartForm.attr('data-add-cart-type') == 'modal'
                    ) {
                      // Cart Modal case
                      _setText($addToCartText, _config.addToCartBtnLabel)
                      _showFeedback(itemData)

                      // ---------------------------------------------
                      // Trap Focus inside the Cart Confirmation Modal
                      // ---------------------------------------------

                      // add all the elements inside modal which you want to make focusable
                      const focusableElements =
                        '[tabindex]:not([tabindex="-1"]), [href]'
                      const modal = document.querySelector(
                        '#modal_cart_confirmation',
                      ) // select the modal by it's id
                      const firstFocusableElement =
                        modal.querySelectorAll(focusableElements)[0] // get first element to be focused inside modal
                      const focusableContent =
                        modal.querySelectorAll(focusableElements)
                      const lastFocusableElement =
                        focusableContent[focusableContent.length - 1] // get last element to be focused inside modal

                      document.addEventListener('keydown', function (e) {
                        let isTabPressed = e.key === 'Tab' || e.keyCode === 9

                        if (!isTabPressed) {
                          return
                        }

                        if (e.shiftKey) {
                          // if shift key pressed for shift + tab combination

                          if (
                            document.activeElement === firstFocusableElement
                          ) {
                            lastFocusableElement.focus() // add focus for the last focusable element
                            e.preventDefault()
                          }
                        } else {
                          // if tab key is pressed

                          if (document.activeElement === lastFocusableElement) {
                            // if focused has reached to last focusable element then focus first focusable element after pressing tab

                            firstFocusableElement.focus() // add focus for the first focusable element
                            e.preventDefault()
                          }
                        }
                      })
                    }
                  }, _config.howLongTillBtnReturnsToNormal)

                  // Update cart count

                  $.ajax({
                    url: _config.shopifyAjaxCartURL,
                    cache: false,
                    dataType: 'json',
                    success: function (cart) {
                      if (
                        _config.cartCountSelector &&
                        $(_config.cartCountSelector).length
                      ) {
                        $(_config.cartCountSelector).text(cart.item_count)
                      }
                    },
                  })
                },
                error: function (XMLHttpRequest) {
                  var response = eval('(' + XMLHttpRequest.responseText + ')')
                  response = response.description
                  if (response.slice(0, 4) === 'All ') {
                    $('.cart__message--error').text(
                      "You can't add more of this product to the cart.",
                    )
                    _setText($addToCartText, _config.soldOutBtnLabel)
                    $addToCartBtn.prop('disabled', true)
                  } else {
                    $('.cart__message--error').text(response)
                    $addToCartBtn
                      .prop('disabled', false)
                      .removeClass('disabled')
                    _setText($addToCartText, _config.addToCartBtnLabel)
                  }
                },
              })

              return false
            },
          )
        }
      })
    }
    return {
      init: function (params) {
        // Configuration
        params = params || {}
        // Merging with defaults.
        $.extend(_config, params)
        // Action
        $(function () {
          _init()
        })
      },
      getConfig: function () {
        return _config
      },
    }
  })($)
  Shopify.AjaxifyCart.init()
})
